import React from 'react';
import './Button.css';
import { Link } from 'react-router-dom';
import { useLogout } from '../../hooks/useLogout';
import { useAuthContext } from '../../hooks/useAuthContext';

export function Button() {
  const { user } = useAuthContext();
  const { logout } = useLogout();
  const handleLogout = () => {
    logout();
  };

  return (
    <>
      {user ? (
        <button className='btn' onClick={handleLogout}>
          Wyloguj się
        </button>
      ) : (
        <Link to='/login'>
          <button className='btn'>Zaloguj się</button>
        </Link>
      )}
    </>
  );
}
